import { render, staticRenderFns } from "./TurnInCounter.vue?vue&type=template&id=1c9d0f2e&scoped=true&"
import script from "./TurnInCounter.vue?vue&type=script&lang=js&"
export * from "./TurnInCounter.vue?vue&type=script&lang=js&"
import style0 from "./TurnInCounter.vue?vue&type=style&index=0&id=1c9d0f2e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c9d0f2e",
  null
  
)

export default component.exports